import { useState } from "react";
import { toast } from "sonner";
import { Pencil, Check, X } from "lucide-react";
import api from "@/lib/api";

export default function RenameTitle({ sc, onSaved }) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(sc.title);
  const [busy, setBusy] = useState(false);

  const save = async () => {
    const t = value.trim();
    if (!t) return toast.error("Title can't be empty");
    if (t === sc.title) return setEditing(false);
    setBusy(true);
    try {
      await api.patch(`/subcourses/${sc.id}`, { title: t });
      toast.success("Study renamed");
      setEditing(false);
      onSaved();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't rename");
    } finally { setBusy(false); }
  };

  if (editing) {
    return (
      <form onSubmit={(e) => { e.preventDefault(); save(); }} className="flex items-center gap-2 max-w-3xl" data-testid="sc-rename-form">
        <input autoFocus value={value} onChange={(e) => setValue(e.target.value)} maxLength={200}
          onKeyDown={(e) => e.key === "Escape" && setEditing(false)}
          className="input text-[22px] font-semibold flex-1" aria-label="Study title" data-testid="sc-rename-input" />
        <button type="submit" disabled={busy} className="btn-icon hover:text-[#B8A4FF]" aria-label="Save title" data-testid="sc-rename-save"><Check size={18} /></button>
        <button type="button" onClick={() => { setEditing(false); setValue(sc.title); }} className="btn-icon" aria-label="Cancel" data-testid="sc-rename-cancel"><X size={18} /></button>
      </form>
    );
  }
  return (
    <div className="flex items-start gap-2 group">
      <h1 className="display-2 max-w-3xl" data-testid="sc-title">{sc.title}</h1>
      <button onClick={() => { setValue(sc.title); setEditing(true); }} className="btn-icon mt-2 opacity-60 hover:opacity-100 hover:text-[#B8A4FF]"
        aria-label="Rename study" title="Rename" data-testid="sc-rename-btn">
        <Pencil size={15} />
      </button>
    </div>
  );
}
